import { queryOptions } from "@tanstack/react-query";
import { type Api, listCoachProductsFees } from "api-client";

export type CoachProductsFee = Api.ListCoachProductsFees.Output.CurrentPage;

interface CoachProductsFeesParams {
  query: string;
  pageIndex: number;
  pageSize: number;
}

export function coachProductsFeesQueryOptions(params: CoachProductsFeesParams) {
  return queryOptions({
    queryKey: ["admin", "coach-products-fees", params],
    queryFn: async () => {
      const response = await listCoachProductsFees({ query: params });
      return response.data.data;
    },
  });
}
